module.exports = __webpack_public_path__ + "static/media/royal_super.bd963541.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/tizon_tardio_papa/curativa/royal_super.png
// module id = 2015
// module chunks = 3